import { Nullable } from "@mapmycustomers/shared";
import Address from "@mapmycustomers/shared/types/Address";
import GeoAddress from "@mapmycustomers/shared/types/GeoAddress";

const geoAddressToNullableAddress = (
  { address, city, countryCode, fullPostalCode, postalCode, region, regionCode }: GeoAddress,
  wasAddressChanged: boolean
): Nullable<Address> => ({
  address: address ?? null,
  city: city ?? null,
  countryCode: countryCode ?? null,
  postalCode: (wasAddressChanged ? undefined : fullPostalCode) ?? postalCode ?? null,
  region: region ?? null,
  regionCode: regionCode ?? null,
});

export default geoAddressToNullableAddress;
